/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import { findRequiredPlugins } from '../findRequiredPlugins/findRequiredPlugins';
import { getPluginByClassName } from '../getPluginByClassName/getPluginByClassName';

export function findUnneededPlugins( editorPlugins: EditorPlugins ): EditorPlugins {
	const pluginsToCheck = editorPlugins.map( getPluginByClassName );

	const requiredPlugins = pluginsToCheck
		.filter( plugin => !plugin.hidden )
		.flatMap( plugin => findRequiredPlugins( plugin.className, editorPlugins ) );

	return pluginsToCheck
		.filter( plugin => plugin.hidden )
		.filter( plugin => !requiredPlugins.includes( plugin.className ) )
		.map( plugin => plugin.className );
}
